<template>
  <CadastrosMotivos />
</template>

<script>
import CadastrosMotivos from '@/components/compra/CadastrosMotivos.vue';

export default {
  components: { CadastrosMotivos }
}
</script>

<style>

</style>
